import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Offcanvas } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import { FaFilter } from "react-icons/fa";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/users`;

const UserDetails = () => {
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const didFetchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [roles, setRoles] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const WithDeletePermission = withPermission(({ children }) => children, ['user-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['user-edit']);
    const WithCreatePermission = withPermission(({ children }) => children, ['user-create']);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [errors, setErrors] = useState({});
    const [dateFilterDropdown, setDateFilterDropdown] = useState(false);
    const [dateRange, setDateRange] = useState({ from: '', to: '' });
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchUsers(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };

    const fetchUsers = async (page = 1) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            let params = { page };

            if (searchQuery) params.search = searchQuery;
            if (dateRange.from) params.from_date = dateRange.from;
            if (dateRange.to) params.to_date = dateRange.to;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,

            });
            const { data, current_page, last_page } = response.data.users;
            const filteredUsers = data.filter(
                (user) => !user.roles?.some((role) => role.name === "superadmin")
            );

            setUsers(filteredUsers);
            // setUsers(data);
            // setPageCount(response.data.last_page);
            // setCurrentPage(response.data.current_page);
            setCurrentPage(current_page - 1);
            setPageCount(last_page);

        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    const fetchRoles = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/roles`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });
            setRoles(response.data.data);
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    };
    useEffect(() => {
        if (showModal && roles.length === 0) {
            fetchRoles();
        }
    }, [showModal]);
    const handleAddUser = () => {
        setFormData({ name: '' });
        setIsEdit(false);
        setSelectedUser(null);
        setShowModal(true);
        setErrors({});

    };

    const handleEditUser = (user) => {
        setFormData({
            name: user.name,
            email: user.email,
            password: '', // Always empty
        });
        setSelectedRole(user.roles[0]?.name || null);
        setIsEdit(true);
        setSelectedUser(user);
        setShowModal(true);
        setErrors({});
    };


    // const handleDelete = async (id) => {
    //     Swal.fire({
    //         title: "Are you sure?",
    //         text: "You won't be able to revert this!",
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#d33",
    //         cancelButtonColor: "#3085d6",
    //         confirmButtonText: "Yes, delete it!"
    //     }).then(async (result) => {
    //         if (result.isConfirmed) {
    //             try {
    //                 const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //                 const origin = localStorage.getItem('user-origin');
    //                 const token = userInfo?.token;
    //                 await axios.delete(`${API_URL}/${id}`, {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`,
    //                         'Tenant-Origin': origin,
    //                     },
    //                 });
    //                 setUsers(users.filter(user => user.id !== id));
    //                 Swal.fire(
    //                     "Deleted!",
    //                     "The user has been deleted.",
    //                     "success"
    //                 );
    //             } catch (error) {
    //                 console.error('Error deleting user:', error);
    //                 Swal.fire(
    //                     "Error!",
    //                     "Failed to delete user. Please try again.",
    //                     "error"
    //                 );
    //             }
    //         }
    //     });

    // };


    const handleDelete = async (user) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    // Delete ledger if it exists
                    const ledgerId = user.ledger_id;
                    const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
                    const backendUrl = `${API}/api`;

                    if (ledgerId) {
                        try {
                            await axios.delete(`${backendUrl}/ledgers/delete/${ledgerId}`, {
                                headers: {
                                    'x-api-key': process.env.REACT_APP_API_KEY,
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                },
                            });
                            console.log(`Ledger with ID ${ledgerId} deleted.`);
                        } catch (ledgerError) {
                            console.warn("Ledger delete failed or not found:", ledgerError.response?.data || ledgerError.message);
                        }
                    }

                    // Delete user
                    await axios.delete(`${API_URL}/${user.id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setUsers(users.filter(u => u.id !== user.id));
                    Swal.fire("Deleted!", "The user has been deleted.", "success");
                } catch (error) {
                    console.error('Error deleting user:', error);
                    Swal.fire("Error!", "Failed to delete user. Please try again.", "error");
                }
            }
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };

    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchUsers(newPage);
    };
    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'The email field must be a valid email address';
        }
        if (!isEdit) {
            if (!formData.password) {
                newErrors.password = 'Password is required';
            } else if (formData.password.length < 8) {
                newErrors.password = 'Password must be at least 8 characters long';
            }
        } else {
            // If password is provided, validate its length
            if (formData.password && formData.password.length < 8) {
                newErrors.password = 'Password must be at least 8 characters long';
            }
        }


        const duplicateEmail = users.some(
            (user) => user.email === formData.email && user.id !== (selectedUser?.id || null)
        );
        if (duplicateEmail) {
            newErrors.email = 'Email must be unique';
        }

        return newErrors;
    };
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;

        // ✅ First validate form
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return; // Stop if validation fails
        }

        setLoading(true); // Optional: show loading indicator

        // ✅ After validation, prepare data to send
        const data = { ...formData, roles: selectedRole ? [selectedRole] : [] };

        // ✅ If editing and password is empty or only spaces, remove it
        if (isEdit && (!formData.password || formData.password.trim() === "")) {
            delete data.password;
        }

        try {
            let response;
            let ledgerId;
            if (isEdit) {
                // ✅ Update user without empty password
                ledgerId = await createOrEnsureLedger(selectedUser?.name, formData.name);
                data.ledger_id = ledgerId;
                response = await axios.put(`${API_URL}/${selectedUser.id}`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setUsers(users.map((ind) => (ind.id === selectedUser.id ? response.data.user : ind)));
                console.log('Old user name:', selectedUser?.name);
                console.log('New user name:', formData.name);
                // await createOrEnsureLedger(selectedUser?.name, formData.name);

            } else {
                // ✅ Create new user
                ledgerId = await createOrEnsureLedger(null, formData.name);
                data.ledger_id = ledgerId;
                response = await axios.post(API_URL, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setUsers([...users, response.data.user]);
                // await createOrEnsureLedger(null, formData.name);

            }
            setErrors({});
            setShowModal(false);
        } catch (error) {
            console.error("Unexpected error: ", error);
        } finally {
            setLoading(false);
        }
    };
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setDateRange((prev) => ({ ...prev, [name]: value }));
    };
    const applyDateFilter = () => {
        setDateFilterDropdown(false); // Close the dropdown after applying
        fetchUsers();
    };
    const clearDateFilter = () => {
        setDateRange({ from: "", to: "" }); // Reset date inputs
    };



    const fetchLedgerByName = async (name) => {
        try {

            const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration'; // Adjust as needed
            const backendUrl = `${API}/api`; // Use this if you want to use dynamic API URL
            const { data: res } = await axios.get(
                `${backendUrl}/ledgers/view/${name}`,
                {
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_KEY,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );
            // If success, return the data
            return res.status === 'success' ? res.data : null;
        } catch (err) {
            // If "Ledger not found", just return null (not a real error)
            if (err.response?.data?.message === 'Ledger not found') {
                console.log(`Ledger "${name}" not found.`);
                return null;
            } else {
                // Real error (server error, API key issue, etc.)
                console.error(`Error fetching ledger "${name}":`, err.response?.data || err.message);
                throw err;
            }
        }
    };
    // const createOrEnsureLedger = async (oldLedgerName, newName) => {
    //     try {
    //         const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration'; // Adjust as needed
    //         const backendUrl = `${API}/api`; // Use this if you want to use dynamic API URL
    //         const oldLedger = oldLedgerName ? await fetchLedgerByName(oldLedgerName) : null;
    //         const newLedger = await fetchLedgerByName(newName);

    //         const nameChanged = oldLedgerName?.toLowerCase() !== newName.toLowerCase();

    //         if (nameChanged) {
    //             if (!oldLedger) {
    //                 console.warn(`Old ledger not found, will create new ledger "${newName}".`);
    //             } else if (newLedger) {
    //                 console.warn(`Cannot rename – ledger "${newName}" already exists.`);
    //                 return;
    //             } else {
    //                 const ledgerId = oldLedger.Ledger?.id || oldLedger.Ledger?.ledger_id;
    //                 if (!ledgerId) {
    //                     console.warn("Old ledger has no valid ID.");
    //                     return;
    //                 }

    //                 // Prepare full update payload
    //                 const ledgerPayload = {
    //                     name: newName,
    //                     group_id: oldLedger.Ledger.group_id,
    //                     code: oldLedger.Ledger.code,
    //                     op_balance: oldLedger.Ledger.op_balance,
    //                     op_balance_dc: oldLedger.Ledger.op_balance_dc,
    //                     type: oldLedger.Ledger.type,
    //                     reconciliation: oldLedger.Ledger.reconciliation,
    //                     notes: oldLedger.Ledger.notes?.substring(0, 500),
    //                 };

    //                 await axios.put(
    //                     `${backendUrl}/ledgers/edit/${ledgerId}`,
    //                     ledgerPayload,
    //                     {
    //                         headers: {
    //                             'x-api-key': process.env.REACT_APP_API_KEY,
    //                             'Accept': 'application/json',
    //                             'Content-Type': 'application/json',
    //                         },
    //                     }
    //                 );
    //                 console.log(`Ledger renamed to "${newName}".`);
    //                 return;
    //             }
    //         }

    //         if (!nameChanged && !newLedger) {
    //             console.log(`Ledger "${newName}" not found, creating.`);
    //         }

    //         if (newLedger) {
    //             console.log(`Ledger "${newName}" already exists, no action needed.`);
    //             return;
    //         }

    //         // Create new
    //         const newLedgerPayload = {
    //             name: newName,
    //             group_id: 10,
    //             op_balance_dc: 'C',
    //             type: 0,
    //             notes: `Ledger for user ${newName}`,
    //             code: null,
    //             reconciliation: 0,
    //             op_balance: 0,
    //         };

    //         await axios.post(`${backendUrl}/ledgers/add`, newLedgerPayload, {
    //             headers: {
    //                 'x-api-key': process.env.REACT_APP_API_KEY,
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //             },
    //         });
    //         console.log(`Ledger "${newName}" created.`);
    //     } catch (err) {
    //         console.error('Ledger creation/rename failed:', err.response?.data || err.message);
    //     }
    // };


    // const createOrEnsureLedger = async (oldLedgerName, newName) => {
    //     try {
    //         const headers = {
    //             'x-api-key': process.env.REACT_APP_API_KEY,
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json',
    //         };

    //         let oldLedger = null;
    //         let newLedger = null;

    //         // Fetch old ledger
    //         if (oldLedgerName) {
    //             try {
    //                 const { data: res } = await axios.get(
    //                     `http://localhost/webzash/api/ledgers/view/${oldLedgerName}`,
    //                     { headers }
    //                 );
    //                 if (res.status === 'success') {
    //                     oldLedger = res.data;
    //                     console.log('Old Ledger Fetched:', oldLedger);
    //                 }
    //             } catch (err) {
    //                 if (err.response?.data?.message !== 'Ledger not found') {
    //                     console.error('Error getting old ledger:', err.response?.data || err.message);
    //                     return;
    //                 }
    //                 console.log(`Old ledger "${oldLedgerName}" not found.`);
    //             }
    //         }

    //         // Fetch new ledger
    //         try {
    //             const { data: res } = await axios.get(
    //                 `http://localhost/webzash/api/ledgers/view/${newName}`,
    //                 { headers }
    //             );
    //             if (res.status === 'success') newLedger = res.data;
    //         } catch (err) {
    //             if (err.response?.data?.message !== 'Ledger not found') {
    //                 console.error('Error getting new ledger:', err.response?.data || err.message);
    //                 return;
    //             }
    //             console.log(`New ledger "${newName}" does not exist (expected if creating).`);
    //         }

    //         // Compare names
    //         const nameChanged = oldLedgerName?.toLowerCase() !== newName.toLowerCase();

    //         // Rename ledger
    //         if (nameChanged) {
    //             if (!oldLedger) {
    //                 console.warn(`Old ledger not found, will create new ledger "${newName}".`);
    //                 // fall through
    //             } else if (newLedger) {
    //                 console.warn(`Cannot rename – new name "${newName}" already exists.`);
    //                 return;
    //             } else {
    //                 const ledgerId = oldLedger?.Ledger?.id || oldLedger?.Ledger?.ledger_id;

    //                 if (!ledgerId) {
    //                     console.warn('Old ledger has no valid ID.', oldLedger);
    //                     return;
    //                 }
    //                 const ledgerPayload = {
    //                     name: newName,
    //                     group_id: oldLedger.Ledger.group_id,
    //                     code: oldLedger.Ledger.code,
    //                     op_balance: oldLedger.Ledger.op_balance,
    //                     op_balance_dc: oldLedger.Ledger.op_balance_dc,
    //                     type: oldLedger.Ledger.type,
    //                     reconciliation: oldLedger.Ledger.reconciliation,
    //                     notes: oldLedger.Ledger.notes?.substring(0, 500), // ensure note not too long
    //                 };

    //                 await axios.put(
    //                     `http://localhost/webzash/api/ledgers/edit/${ledgerId}`,
    //                     ledgerPayload,
    //                     { headers }
    //                 );
    //                 console.log(`Ledger renamed from "${oldLedgerName}" to "${newName}".`);
    //                 return;
    //             }
    //         }

    //         // Create if not found
    //         if (!nameChanged && !newLedger) {
    //             console.log(`Ledger "${newName}" does not exist, creating.`);
    //         }

    //         // If exists, no action
    //         if (newLedger) {
    //             console.log(`Ledger "${newName}" already exists, no action needed.`);
    //             return;
    //         }

    //         // Create new
    //         const ledgerData = {
    //             name: newName,
    //             group_id: 10,
    //             op_balance_dc: 'C',
    //             type: 1,
    //             notes: `Ledger for user ${newName}`,
    //             code: null,
    //             reconciliation: 0,
    //             op_balance: 0,
    //         };

    //         await axios.post('http://localhost/webzash/api/ledgers/add', ledgerData, { headers });
    //         console.log(`Ledger "${newName}" created.`);
    //     } catch (error) {
    //         console.error('Ledger creation/rename failed:', error.response?.data || error.message);
    //     }
    // };




    const getGroupIdByName = async (groupName, parentGroupName = null) => {
        const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
        const backendUrl = `${API}/api`;

        try {
            const { data } = await axios.get(`${backendUrl}/groups/index`, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            console.log("🔍 Raw response from /groups/index:", data);

            const groupList = Array.isArray(data) ? data : data?.data || [];

            const flatGroups = groupList.map(g => g.Group);
            console.log("Available groups:", flatGroups.map(g => g.name));
            const normalize = (str) => str?.toLowerCase().trim();

            // ✅ First try to find by name directly (ignoring parent)
            let targetGroup = flatGroups.find(g => normalize(g.name) === normalize(groupName));

            if (targetGroup) {
                return targetGroup.id;
            }

            // 🔁 If not found, optionally filter by parent (only if explicitly required)
            if (parentGroupName) {
                const parent = flatGroups.find(g => normalize(g.name) === normalize(parentGroupName));

                if (!parent) {
                    console.error(`❌ Parent group "${parentGroupName}" not found.`);
                    console.warn("Available groups:", flatGroups.map(g => g.name));
                    return null;
                }

                const parentGroupId = parent.id;

                targetGroup = flatGroups.find(
                    g => normalize(g.name) === normalize(groupName) && g.parent_id === parentGroupId
                );

                if (targetGroup) {
                    return targetGroup.id;
                }

                console.error(`❌ Group "${groupName}" under "${parentGroupName}" not found.`);
                console.warn("Available groups:", flatGroups.map(g => ({ name: g.name, parent_id: g.parent_id })));
                return null;
            }

            // ❌ Not found at all
            console.error(`❌ Group "${groupName}" not found.`);
            console.warn("Available groups:", flatGroups.map(g => g.name));
            return null;
        } catch (err) {
            console.error(`❌ Failed to fetch groups:`, err.response?.data || err.message);
            return null;
        }
    };




    // const createOrEnsureLedger = async (oldLedgerName, newName) => {
    //   const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
    //   const backendUrl = `${API}/api`;

    //   const nameChanged = oldLedgerName?.toLowerCase() !== newName.toLowerCase();

    //   try {
    //     // ✅ Rename flow if name changed
    //     if (oldLedgerName && nameChanged) {
    //       try {
    //         const oldLedger = await fetchLedgerByName(oldLedgerName);
    //         if (!oldLedger) {
    //           console.warn(`Old ledger "${oldLedgerName}" not found.`);
    //           return;
    //         }

    //         const ledgerId = oldLedger.Ledger?.id || oldLedger.Ledger?.ledger_id;
    //         if (!ledgerId) {
    //           console.warn("Old ledger has no valid ID.");
    //           return;
    //         }

    //         const ledgerPayload = {
    //           name: newName,
    //           group_id: oldLedger.Ledger.group_id,
    //           code: oldLedger.Ledger.code,
    //           op_balance: oldLedger.Ledger.op_balance,
    //           op_balance_dc: oldLedger.Ledger.op_balance_dc,
    //           type: oldLedger.Ledger.type,
    //           reconciliation: oldLedger.Ledger.reconciliation,
    //           notes: oldLedger.Ledger.notes?.substring(0, 500),
    //           deduction_rate: oldLedger.Ledger.deduction_rate || 0,
    //         };

    //         await axios.put(`${backendUrl}/ledgers/edit/${ledgerId}`, ledgerPayload, {
    //           headers: {
    //             'x-api-key': process.env.REACT_APP_API_KEY,
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json',
    //           },
    //         });

    //         console.log(`Ledger renamed to "${newName}".`);
    //         return;
    //       } catch (renameError) {
    //         console.warn("Rename failed, possibly name exists:", renameError.response?.data || renameError.message);
    //         return;
    //       }
    //     }

    //    const targetGroupName = "Loans (Liabilities)";
    //    const parentGroupName = "Liabilities and Owners Equity";

    //     const groupId = await getGroupIdByName(targetGroupName, parentGroupName);

    //     if (!groupId) {
    //       console.error(`Cannot create ledger: Group "${targetGroupName}" not found.`);
    //       return;
    //     }

    // const newLedgerPayload = {
    //   Ledger: 
    //     {
    //       name: newName,
    //       group_id: groupId,
    //       op_balance_dc: 'C',
    //       type: 0,
    //       notes: `Ledger for user ${newName}`.substring(0, 500),
    //       code: null, // or generate a unique code if necessary
    //       reconciliation: 0,
    //       op_balance: 0,
    //       deduction_rate: 100
    //     }

    // };


    //     await axios.post(`${backendUrl}/ledgers/add`, newLedgerPayload, {
    //       headers: {
    //         'x-api-key': process.env.REACT_APP_API_KEY,
    //         'Accept': 'application/json',
    //         'Content-Type': 'application/json',
    //       },
    //     });

    //     console.log(`Ledger "${newName}" created under "${targetGroupName}".`);
    //   } catch (err) {
    //     if (err.response?.data?.message?.includes("already exists")) {
    //       console.warn(`Ledger "${newName}" already exists.`);
    //     } else {
    //       console.error("Ledger creation/rename failed:", err.response?.data || err.message);
    //     }
    //   }
    // };

    const createOrEnsureLedger = async (oldLedgerName, newName) => {
        const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
        const backendUrl = `${API}/api`;
        const nameChanged = oldLedgerName?.toLowerCase() !== newName.toLowerCase();

        try {
            // ✅ Rename flow if name changed
            if (oldLedgerName && nameChanged) {
                try {
                    const oldLedger = await fetchLedgerByName(oldLedgerName);
                    if (!oldLedger) {
                        console.warn(`Old ledger "${oldLedgerName}" not found.`);
                        return;
                    }

                    const ledgerId = oldLedger.Ledger?.id || oldLedger.Ledger?.ledger_id;
                    if (!ledgerId) {
                        console.warn("Old ledger has no valid ID.");
                        return;
                    }

                    const ledgerPayload = {
                        name: newName,
                        group_id: oldLedger.Ledger.group_id,
                        code: oldLedger.Ledger.code,
                        op_balance: oldLedger.Ledger.op_balance,
                        op_balance_dc: oldLedger.Ledger.op_balance_dc,
                        type: oldLedger.Ledger.type,
                        reconciliation: oldLedger.Ledger.reconciliation,
                        notes: oldLedger.Ledger.notes?.substring(0, 500),
                        deduction_rate: oldLedger.Ledger.deduction_rate || 0,
                    };

                    await axios.put(`${backendUrl}/ledgers/edit/${ledgerId}`, ledgerPayload, {
                        headers: {
                            'x-api-key': process.env.REACT_APP_API_KEY,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        },
                    });

                    console.log(`Ledger renamed to "${newName}".`);
                    return ledgerId;
                } catch (renameError) {
                    console.warn("Rename failed, possibly name exists:", renameError.response?.data || renameError.message);
                    return;
                }
            }

            // ✅ Skip if new ledger already exists
            const existingLedger = await fetchLedgerByName(newName);
            if (existingLedger && existingLedger.Ledger) {
                console.log(`Ledger "${newName}" already exists. Skipping creation.`);
                return existingLedger.Ledger.id || existingLedger.Ledger.ledger_id; // ✅ Ensure it returns the ID
            }


            const targetGroupName = "Loans (Liabilities)";
            const parentGroupName = "Liabilities and Owners Equity";
            const groupId = await getGroupIdByName(targetGroupName, parentGroupName);

            if (!groupId) {
                console.error(`Cannot create ledger: Group "${targetGroupName}" not found.`);
                return;
            }

            const newLedgerPayload = {
                Ledger: {
                    name: newName,
                    group_id: groupId,
                    op_balance_dc: 'C',
                    type: 0,
                    notes: `Ledger for user ${newName}`.substring(0, 500),
                    code: null,
                    reconciliation: 0,
                    op_balance: 0,
                    deduction_rate: 100
                }
            };

            const res = await axios.post(`${backendUrl}/ledgers/add`, newLedgerPayload, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            const ledgerId = res.data?.data?.Ledger?.id || res.data?.ledger?.id;
            console.log('New ledger created with ID:', ledgerId);
            return ledgerId;

            console.log(`Ledger "${newName}" created under "${targetGroupName}".`);
        } catch (err) {
            if (err.response?.data?.message?.includes("already exists")) {
                console.warn(`Ledger "${newName}" already exists.`);
            } else {
                console.error("Ledger creation/rename failed:", err.response?.data || err.message);
            }
        }
    };

   const handleImport = async (event) => {
            const file = event.target.files[0];
            if (!file) return;
    
            try {
                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;
    
                const formData = new FormData();
                formData.append('file', file);
    
                const response = await axios.post(
                    `${backendUrl}/api/users/import`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data',
                            'Tenant-Origin': origin,
                        },
                    }
                );
    
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message || ` Imported successfully!`,
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
    
                // Refresh the list after import
                setTimeout(() => window.location.reload(), 1000);
    
                // Clear the file input
                event.target.value = '';
    
            } catch (error) {
                console.error('Import error:', error);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
                event.target.value = "";
    
            } finally {
            }
        };
    
        // Export Functions
        const handleExport = async () => {
            try {
                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;
    
                const response = await axios.get(
                    `${backendUrl}/api/users/export`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                        responseType: 'blob', // Important for file download
                    }
                );
    
                // Create blob link and download
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
    
                // Get filename from response headers or use default
                const contentDisposition = response.headers['content-disposition'];
                let filename = `Users_${new Date().toISOString().split('T')[0]}.xlsx`;
    
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                    if (filenameMatch.length === 2) {
                        filename = filenameMatch[1];
                    }
                }
    
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
    
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: `Exported successfully!`,
                    timer: 2000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
    
            } catch (error) {
                console.error('Export error:', error);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: `Failed to export`,
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            } finally {
            }
        };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid ">
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">User</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript:void(0);">User</a></li>
                                        <li className="breadcrumb-item active">User List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 ">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                           <div className="d-flex align-items-center gap-2">
                                            {/* Export Button */}
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            {/* Import Button */}
                                            <input
                                                type="file"
                                                accept=".xlsx, .xls"
                                                id="importLeadsFile"
                                                onChange={handleImport}
                                                style={{ display: "none" }}
                                            />
                                            <label
                                                htmlFor="importLeadsFile"
                                                className="btn btn-light border mb-0"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Import"
                                            >
                                                <i className="mdi mdi-upload text-primary"></i>
                                            </label>
                                        <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={handleAddUser} data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Add User"
                                            >
                                                <i className="mdi mdi-plus" ></i>
                                            </button>                                            </WithCreatePermission>
                                    </div>
                                    </div>
                                    <div>
                                        <table className="table align-middle table-nowrap table-check table-list">

                                            <thead className="table-sales-gradient">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th className="align-middle"> User Name</th>
                                                    <th className="align-middle">Email</th>
                                                    <th className="align-middle">Role</th>

                                                    <th className="align-middle">Created On
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setDateFilterDropdown(!dateFilterDropdown)}
                                                            />
                                                            {dateFilterDropdown && (
                                                                <div className="dropdown-menu show p-3" style={{ minWidth: '250px' }}>
                                                                    <label className="form-label">From</label>
                                                                    <input type="date" className="form-control mb-2" name="from" value={dateRange.from} onChange={handleDateChange} />

                                                                    <label className="form-label">To</label>
                                                                    <input type="date" className="form-control mb-2" name="to" value={dateRange.to} onChange={handleDateChange} />

                                                                    <div className="text-end mt-3">
                                                                        <button className="btn btn-primary btn-sm d-inline-block w-auto me-2" onClick={applyDateFilter}>
                                                                            Apply
                                                                        </button>
                                                                        <button className="btn btn-secondary btn-sm d-inline-block w-auto" onClick={clearDateFilter}>
                                                                            Clear
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </th>

                                                    <th className="align-middle">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(users) && users.length > 0 ? (
                                                    users.map((user, index) => (
                                                        <tr key={user.id}>
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`instanceCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`instanceCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td>{index + 1}</td>
                                                            <td>{user.name}</td>
                                                            <td>{user.email}</td>
                                                            <td>
                                                                {user.roles && user.roles.length > 0 ? (
                                                                    user.roles.map((role, idx) => (
                                                                        <span key={idx} >
                                                                            {role.name}
                                                                        </span>
                                                                    ))
                                                                ) : (
                                                                    <span className="text-muted"></span>
                                                                )}
                                                            </td>


                                                            <td>{new Date(user.created_at).toLocaleDateString()}</td>

                                                            <td>
                                                                <div className="dropdown">
                                                                    <i
                                                                        className="mdi mdi-dots-horizontal font-size-18"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                        <li><WithEditPermission>
                                                                            <button className="dropdown-item" onClick={() => handleEditUser(user)}>
                                                                                Edit
                                                                            </button></WithEditPermission>
                                                                        </li>
                                                                        <li><WithDeletePermission>
                                                                            <button className="dropdown-item" onClick={() => handleDelete(user)}>
                                                                                Delete
                                                                            </button></WithDeletePermission>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">No users found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageChange}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                    {/* Modal for Add/Edit User */}
                                    <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement='end' style={{ width: '450px' }}>
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title>{isEdit ? 'Edit User' : 'Add User'}</Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <hr style={{ margin: 0 }} /><br />


                                        <Offcanvas.Body>
                                            <Form>
                                                <Form.Group controlId="userName" className='mb-3'>
                                                    <Form.Label>User Name</Form.Label>
                                                    <Form.Control type="text" name="name" value={formData.name} onChange={handleInputChange}
                                                        className={`form-control ${errors?.name ? 'is-invalid' : ''}`}

                                                    />

                                                    {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}


                                                </Form.Group>

                                                <Form.Group controlId="useremail" className='mb-3'>
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control type="email" name="email" value={formData.email} onChange={handleInputChange}
                                                        className={`form-control ${errors?.email ? 'is-invalid' : ''}`}

                                                    />
                                                    {errors.email && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.email}</div>}

                                                </Form.Group>


                                                <Form.Group controlId="userpass" className='mb-3'>
                                                    <Form.Label>password</Form.Label>
                                                    <Form.Control type="password" name="password" onChange={handleInputChange} className={`form-control ${errors?.password ? 'is-invalid' : ''}`}

                                                    />
                                                    {errors.password && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.password}</div>}
                                                </Form.Group>

                                                <Form.Group controlId="userRole" className='mb-3'>
                                                    <Form.Label>Role</Form.Label>
                                                    <Form.Select
                                                        value={selectedRole}
                                                        onChange={(e) => setSelectedRole(e.target.value)}
                                                    >
                                                        <option value="">Select Role</option>
                                                        {roles.map((role) => (
                                                            <option key={role.id} value={role.name}>
                                                                {role.name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Form>
                                        </Offcanvas.Body>

                                        <div className="p-3 d-flex justify-content-end border-top">
                                            <Button variant="secondary me-2" onClick={() => setShowModal(false)}>Close</Button>
                                            <Button variant="secondary" onClick={handleSubmit}>{isEdit ? 'Update' : 'Save'} </Button>
                                        </div>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserDetails;
